import styled from 'styled-components';

export default {
  Container: styled.div<{ noInline?: boolean }>`
    cursor: pointer;
    display: ${props => (props.noInline ? 'block' : 'inline-block')};
  `
};
